import React from 'react';
import styled from 'styled-components';
import { HideFor } from '@zocdoc-frontend-common/styles-grid';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import Lock from '@zocdoc-frontend-common/assets-icons/Lock';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const SecureBookingMessage = (color = blue100) => {
    return (
        <Message>
            <StyledLock {...color} />
            <Text>Secure booking</Text>
        </Message>
    );
};

const Message = styled(HideFor).attrs({
    xxsmall: true,
    xsmall: true,
})`
    margin: 16px 0 0;
`;

const StyledLock = styled(Lock)`
    display: inline-block;
    height: 18px;
    margin-right: 7px;
    vertical-align: middle;
`;

const Text = styled.div`
    display: inline-block;
    font: 12px/16px ${FontFamily.SharpSansMedium};
`;

export default SecureBookingMessage;
